import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableUpcomingContent = Loadable({
  loader: function loader() {
    return import('../UpcomingContent.jsx');
  },
  loading: ComponentLoading
});
export default LoadableUpcomingContent;